import { formattedUserFacingMonthDayYearLong } from 'DateHelpers';
import { type FileUpdatedAt } from './FrontRoyalUpload.types';

// Formats an upload's timestamp for display.
//
// S3TranscriptAsset and S3SupplementalEnrollmentDocument send epoch seconds (Rails `to_timestamp`),
// S3EnglishLanguageProficiencyDocument sends a raw timestamp that serialises as an ISO string, and a
// document read off the Iguana currentUser already holds a Date — which would be NaN if multiplied.
// useDateThreshold=false matches the old templates' amDateFormat.
export function uploadedOn(fileUpdatedAt: FileUpdatedAt) {
    const date = typeof fileUpdatedAt === 'number' ? new Date(fileUpdatedAt * 1000) : new Date(fileUpdatedAt);
    return formattedUserFacingMonthDayYearLong(date, false);
}
